import { render, staticRenderFns } from "./blockExercise.vue?vue&type=template&id=8b9f00e2&scoped=true"
import script from "./blockExercise.vue?vue&type=script&lang=js"
export * from "./blockExercise.vue?vue&type=script&lang=js"
import style0 from "./blockExercise.vue?vue&type=style&index=0&id=8b9f00e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9f00e2",
  null
  
)

export default component.exports